export default __webpack_public_path__ + "static/media/footerarrowup.f0905e43.png";